export default __webpack_public_path__ + "static/media/pic_who_we_are.9cd9715c.png";